import { _js } from '@ifixit/utils/localize';
import { MediaItem } from '../MediaLibrary/item';
import { Auth } from 'Shared/auth';

// Add a menu to each image. The image must be standard size or larger, and
// the image must have the class 'hasMenu'.
onDomReady(() => {
   $$('img.' + ImageMenu.enableClass + ':not(.lazyload)').each(ImageMenu.installMenu);

   window.addEventListener('lazyloaded', ev => {
      if (ev.target.hasClass(ImageMenu.enableClass)) {
         if (ev.target.lazyloaded == 1) {
            ev.target.lazyloaded = 1;
         } else {
            ImageMenu.installMenu(ev.target);
         }
      }
   });
});

// eslint-disable-next-line no-var
export var ImageMenu = new Class({
   Implements: [Options, Events],

   options: {},

   // Whether or not the menu may be shown by a mouseenter event.
   enabled: false,

   showing: false,

   initialize: function (img, guid, options) {
      this.setOptions(options);
      this.img = img;
      this.guid = guid;
      this.menu = new Element('ul');
      this.menu.setAttribute('class', 'imageMenu');
      this.img.addEvents({
         mouseenter: this.show.bind(this),
         mouseleave: this.mouseLeave.bind(this),
      });
      this.enable();
   },

   show: function () {
      if (this.enabled) {
         if (this.showing) {
            // We might want to return this anyway, just to allow chaining.
            return null;
         }

         let after = this.img;
         let parent;
         while ((parent = after.getParent()).get('tag') != 'div') {
            after = parent;
         }
         this.menu.inject(after, 'before');
         let imgPos = this.img.getPosition(this.img.getOffsetParent());
         let d;
         if ((d = Number.parseInt(this.img.getStyle('border-left-width'), 10)) > 0) {
            imgPos.x += d;
         }
         if ((d = Number.parseInt(this.img.getStyle('border-top-width'), 10)) > 0) {
            imgPos.y += d;
         }
         this.menu.setStyles({
            right: imgPos.x,
            top: imgPos.y,
         });
         this.menu.classList.add('opacity-0', 'transition-opacity', 'duration-200');
         requestAnimationFrame(() => {
            this.menu.classList.remove('opacity-0');
            this.menu.classList.add('opacity-100');
         });

         this.showing = true;
         this.fireEvent('menushow');
      }
      return this;
   },

   hide: function () {
      this.menu.classList.remove('opacity-100');
      this.menu.classList.add('opacity-0');
      setTimeout(() => {
         this.dispose(this.menu);
      }, 200);
      this.showing = false;
      this.fireEvent('menuhide');
      return this;
   },

   dispose: function (obj) {
      obj.dispose();
   },

   mouseLeave: function (ev) {
      let related = ev.event.relatedTarget;
      if (related && related != this.menu && $(related).getParent('ul') != this.menu) {
         this.hide();
      }
   },

   enable: function () {
      this.enabled = true;
      return this;
   },

   disable: function () {
      this.enabled = false;
      return this;
   },

   // A URL item is an anchor, so middle and cmd click still open it in a
   // tab; an action item is a button, because an anchor with no href is
   // neither focusable nor in the accessibility tree.
   addItem: function (title, action, attributes) {
      let control;
      if (typeof action == 'function') {
         control = new Element('button', { html: title, type: 'button' });
         control.addEvent('click', ev => {
            ev.stop();
            action(this.guid, this.img.getParent());
         });
      } else {
         control = new Element('a', {
            html: title,
            href: action.substitute({ guid: this.guid }),
         });
      }
      if (attributes) {
         control.set(attributes);
      }
      let item = new Element('li').adopt(control).inject(this.menu);
      return item;
   },

   hideItem: function (item) {
      item.hide();
   },

   showItem: function (item) {
      item.show();
   },
});

ImageMenu.enableClass = 'hasMenu';

ImageMenu.installMenu = function (img) {
   let imgData;

   if (
      !img.hasClass(ImageMenu.enableClass) ||
      !(imgData = ImageMenu.parseSrc(img)) ||
      img.getParent('.noImageMenu')
   ) {
      return null;
   }

   let menu = new ImageMenu(img, imgData.guid);
   let copyItem;

   menu.addItem(
      window.guide_constants.fa('SEARCH_PLUS') + ' ',
      async guid => {
         const { openImageLightbox } = await import('Shared/ImageLightbox');
         openImageLightbox(
            window.shared_constants.GuideURI('GUIDE_IMAGE_REDIRECT_ORIGINAL') + guid
         );
      },
      { title: _js('View full screen') }
   );

   // Add the copy option if the image doesn't have the "noCopy" class. This
   // menu item removes itself once selected using the reference to the menu
   // item returned by addItem.
   if (!img.hasClass('noCopy') && Auth.isLoggedIn()) {
      copyItem = menu.addItem(
         window.guide_constants.fa('FILES_O'),
         (guid, container) => {
            MediaItem.copyToMediaLibrary(guid, 'GuideImage', /* callback */ null, container);
         },
         { title: _js('Copy to Media Manager'), class: 'copy-media' }
      );
   }

   // Add the View Metadata option.
   menu.addItem(
      window.guide_constants.fa('INFO_CIRCLE'),
      window.shared_constants.GuideURI('GUIDE_IMAGE_METADATA') + imgData.guid,
      { title: _js('View Metadata'), class: 'media-metadata', rel: 'nofollow' }
   );

   img.store('ImageMenu:imageMenu', menu);
   return menu;
};

ImageMenu.getMenu = function (img) {
   return img.retrieve('ImageMenu:imageMenu');
};

ImageMenu.parseSrc = function (img) {
   let src = img.dataset.src || img.getAttribute('src');
   let match = src.match(/\/([\dA-Za-z]+)(\.(\w+))?($|\?)/);

   if (!match) {
      return false;
   }

   return {
      guid: match[1],
      size: match[2],
   };
};
